module.exports = __webpack_public_path__ + "img/toggle-dark-01.132c6e8b.png";